import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["level", "className", "style"];
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import React from 'react';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';

var getColorForLevel = function getColorForLevel(level) {
  if (level.toString() === '1') {
    return 'neutral-dark';
  }

  if (level.toString() === '3') {
    return 'neutral-lightest';
  }

  return 'neutral-lighter';
};
/**
 * Composes the horizontal rule (<hr>) standard
 * HTML element which provides a thematic break between
 * content.
 *
 * With this implementation of Divider, we reset the
 * default border and use a border-top to style the <hr>.
 */


export var Divider = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 2 : _ref$level,
      className = _ref.className,
      style = _ref.style,
      other = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedClassNameStylePropsWarning('Divider', {
    className: className
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    "data-currency": "Divider",
    component: "hr",
    border: "0",
    borderTop: "1",
    borderColor: getColorForLevel(level) // Removes the default vertical margin on the underlying `<hr>` element
    ,
    marginY: "0",
    className: className,
    style: style,
    ref: ref
  }, other));
});
Divider.displayName = 'Divider';